import React, { useState } from "react";

export default function DetailProductModal({ onClose, product }) {
    const [status, setStatus] = useState(product.status); // Gerenciar o status do produto, se necessário

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };

    const formatarParaBRL = (valor)  => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    }

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black/70 backdrop-blur-md z-50 p-4">
            <div className="glass-panel p-8 w-full max-w-4xl bg-slate-900/90 shadow-2xl border-white/10 relative overflow-y-auto max-h-[90vh]">
                {/* Título */}
                <div className="text-center mb-8">
                    <h2 className="text-2xl font-bold text-white">{product.nome}</h2>
                </div>

                <hr className="border-t border-white/10 my-6" />

                {/* Informações do Produto */}
                <h5 className="text-xl font-semibold text-gray-200 mt-6">Informações do Produto</h5>
                <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
                    <div>
                        <label className="block text-sm text-gray-500">Código</label>
                        <p className="text-gray-200">{product.id}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Valor de Compra</label>
                        <p className="text-gray-200">{formatarParaBRL(product.valor)}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Valor de Venda</label>
                        <p className="text-gray-200">{formatarParaBRL(product.valor_venda)}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Categoria</label>
                        <p className="text-gray-200">{product.categoria}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Quantidade em Estoque</label>
                        <p className="text-gray-200">{product.quantidade}</p>
                    </div>
                </div>

                {/* Descrição do Produto */}
                <h5 className="text-xl font-semibold text-gray-200 mt-10">Descrição</h5>
                <div className="mb-6">
                    <p className="text-gray-200">{product.descricao}</p>
                </div>

                {/* Botão de Fechar */}
                <div className="flex justify-center mt-8">
                    <button
                        onClick={onClose}
                        className="glass-button bg-gray-600 hover:bg-gray-700 w-full sm:w-auto px-10"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
}
